import { envEnum, getEnv } from './utils/crossEnv'

const getServerUrl = (country: string, service: 'CRM' | 'AUTH'): string => {
  const envVar = `${
    service === 'CRM' ? 'BROWSER_CRM' : 'BROWSER_AUTH'
  }_BACKEND_SERVER_${country.toUpperCase()}` as keyof typeof envEnum

  try {
    return getEnv(envEnum[envVar])
  } catch {
    return getHardcodedFallback(country, service)
  }
}

const getHardcodedFallback = (country: string, service: 'CRM' | 'AUTH'): string => {
  const environment = getEnv(envEnum.NEXT_PUBLIC_ENVIRONMENT)

  const fallbacks = {
    dev: {
      CRM: 'master-crm-facade-mi.dev.mi.aservices.tech',
      AUTH: 'master-auth-facade-mi.dev.mi.aservices.tech',
    },
    rc: {
      CRM: 'stable-crm-facade-mi.rc.mi.aservices.tech',
      AUTH: 'stable-auth-facade-mi.rc.mi.aservices.tech',
    },
    prod: {
      CRM: {
        ru: 'https://api.action-media.ru/mi/crm-facade',
        kz: 'https://capi.mcfr.kz/mi/crm-facade',
        uz: 'https://capi.mcfr.uz/mi/crm-facade',
        ua: 'https://api.action-media.ru/mi/crm-facade',
      },
      AUTH: {
        ru: 'https://api.action-media.ru/mi/auth-facade',
        kz: 'https://capi.mcfr.kz/mi/auth-facade',
        uz: 'https://capi.mcfr.uz/mi/auth-facade',
        ua: 'https://api.action-media.ru/mi/auth-facade',
      },
    },
  }

  if (environment === 'prod') {
    const prodFallback = fallbacks.prod[service]

    if (typeof prodFallback === 'object') {
      return prodFallback[country as keyof typeof prodFallback] || prodFallback.ru
    }

    return prodFallback
  }

  const envFallback = fallbacks[environment as keyof typeof fallbacks]?.[service] || fallbacks.dev[service]

  return typeof envFallback === 'string' ? envFallback : envFallback.ru || ''
}

export const ENV_URLS = {
  dev: {
    CRM_BACKEND_SERVER: {
      ru: getServerUrl('ru', 'CRM'),
      kz: getServerUrl('kz', 'CRM'),
      uz: getServerUrl('uz', 'CRM'),
      ua: getServerUrl('ua', 'CRM'),
    },
    AUTH_BACKEND_SERVER: {
      ru: getServerUrl('ru', 'AUTH'),
      kz: getServerUrl('kz', 'AUTH'),
      uz: getServerUrl('uz', 'AUTH'),
      ua: getServerUrl('ua', 'AUTH'),
    },
    CRM_BACKEND_SERVER_PORT: undefined,
    AUTH_BACKEND_SERVER_PORT: undefined,
  },
  rc: {
    CRM_BACKEND_SERVER: {
      ru: getServerUrl('ru', 'CRM'),
      kz: getServerUrl('kz', 'CRM'),
      uz: getServerUrl('uz', 'CRM'),
      ua: getServerUrl('ua', 'CRM'),
    },
    AUTH_BACKEND_SERVER: {
      ru: getServerUrl('ru', 'AUTH'),
      kz: getServerUrl('kz', 'AUTH'),
      uz: getServerUrl('uz', 'AUTH'),
      ua: getServerUrl('ua', 'AUTH'),
    },
    CRM_BACKEND_SERVER_PORT: undefined,
    AUTH_BACKEND_SERVER_PORT: undefined,
  },
  prod: {
    CRM_BACKEND_SERVER: {
      ru: getServerUrl('ru', 'CRM'),
      kz: getServerUrl('kz', 'CRM'),
      uz: getServerUrl('uz', 'CRM'),
      ua: getServerUrl('ua', 'CRM'),
    },
    AUTH_BACKEND_SERVER: {
      ru: getServerUrl('ru', 'AUTH'),
      kz: getServerUrl('kz', 'AUTH'),
      uz: getServerUrl('uz', 'AUTH'),
      ua: getServerUrl('ua', 'AUTH'),
    },
    CRM_BACKEND_SERVER_PORT: undefined,
    AUTH_BACKEND_SERVER_PORT: undefined,
  },
}
